// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__G41Gm","content":"RecentSearches_content__2d9sO"};